<template>
  <div class="d-flex">
    <button 
      v-if="!powerHourStart || timeRemaining < 0"
      class="btn btn-block btn-lg btn-white"
      @click.prevent="startPowerHour"
    >
      <i class="fa fa-clock-o mr-1"></i>
      Start Power Hour
    </button>  
    <button 
      v-if="powerHourStart && timeRemaining > 0 && !pausedAt"
      class="btn btn-block btn-lg btn-dark"
      @click.prevent="pausePowerHour"
    >
      <span v-html="timeRemainingInPowerHour"></span>
      <i class="fa fa-pause ml-2"></i>
    </button> 
    <button
      v-if="powerHourStart && timeRemaining > 0 && pausedAt"
      class="btn btn-block btn-lg btn-danger"
      @click.prevent="resumePowerHour"
    >
      <span v-html="timeRemainingInPowerHour"></span>
      <i class="fa fa-play ml-2"></i>
    </button>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import urls from '@/api/urls'

let powerHourUpdateInterval = null

export default {
  props: {
    plan: {
      type: [Object],
      default () {
        return {
          user: {
            id: null
          },
          year: null
        }
      }
    }
  },
  data () {
    return {
      urls,
      powerHourStart: 0,
      pausedAt: null,
      timeRemaining: 0,
      timeRemainingInPowerHour: 0
    }
  },
  methods: {
    pausePowerHour () {
      clearInterval(powerHourUpdateInterval)
      this.pausedAt = new Date().getTime()
    },
    resumePowerHour () {
      if (this.pausedAt) {
        let elapsed = this.pausedAt - this.powerHourStart
        this.powerHourStart = new Date().getTime() - elapsed
        this.pausedAt = null
      }

      powerHourUpdateInterval = setInterval(() => {
        this.timeRemaining = (60 * 60 * 1000) - (new Date().getTime() - this.powerHourStart)
        let ms = this.timeRemaining
        if (ms <= 0) {
          this.timeRemainingInPowerHour = '0:00:00 <i class="fa fa-flag-checkered ml-1" />'
        } else {
          let hours = Math.floor(ms / (60 * 60 * 1000))
          ms -= hours * 60 * 60 * 1000
          let mins = Math.floor(ms / (60 * 1000))
          ms -= mins * 60 * 1000
          let secs = Math.floor(ms / 1000)
          ms -= secs * 1000
          this.timeRemainingInPowerHour = `${hours}:${mins < 10 ? '0' + mins : mins}:${secs < 10 ? '0' + secs : secs} <i class="fa fa-clock-o ml-1"></i>`
        }
      }, 100)
    },
    startPowerHour () {
      this.powerHourStart = new Date().getTime()
      this.resumePowerHour()
    }
  }
}
</script>